import { Injectable } from '@angular/core';
import { HttpService } from '../../http/http.service';
import { DialogService, IDialogHandle } from '../../dialogs/dialog.service';
import { EAlertTypes } from '../../dialogs/alert/alert.component';
import { TranslateService } from '@ngx-translate/core';
import { AccountService } from '../../services/account.service';
import { tap } from 'rxjs/operators';
import { ApiEndpointService } from '../../services/api-endpoint.service';
import { Observable } from 'rxjs';

interface IQuotaData {
  totalStorageSpace: number;
  remainingStorageSpace: number;
}

@Injectable({ providedIn: 'root' })
export class FilesQuotaService {
  public remainingStorageSpace = 0;
  public totalStorageSpace = 500;
  public isQuotaExceeded = false;
  readonly fileManagerBaseUrl: string;

  constructor(
    private accountService: AccountService,
    private translate: TranslateService,
    private dialogService: DialogService,
    private httpService: HttpService,
    private apiEndpoint: ApiEndpointService
  ) {
    this.fileManagerBaseUrl = `${this.accountService.baseUrl}/api/FileManager_v2/`;
  }

  public subscribeToGetStorageQuota = (): Observable<unknown> => {
    return this.getStorageQuota().pipe(
      tap((data: IQuotaData) => this.handleGetStorageQuotaResult(data),
      () => this.handleGetStorageQuotaError())
    );
  }

  private handleGetStorageQuotaError = () => console.log('error in handleGetStorageQuota');

  public openQuotaExceededDialog = (): IDialogHandle => {
    return this.dialogService.alert({
      header: this.translate.instant('COMMON.QUOTA.STORAGE_QUOTA_EXCEEDED.HEADER'),
      message: this.translate.instant('COMMON.QUOTA.STORAGE_QUOTA_EXCEEDED.MESSAGE'),
      type: EAlertTypes.Alert,
      okCaption: this.translate.instant('COMMON.QUOTA.STORAGE_QUOTA_EXCEEDED.OK'),
    });
  }

  public handleGetStorageQuotaResult = (res: IQuotaData): void => {
    this.remainingStorageSpace = res.remainingStorageSpace;
    this.totalStorageSpace = res.totalStorageSpace;
    if (this.remainingStorageSpace <= 0) {
      this.isQuotaExceeded = true;
    } else {
      this.isQuotaExceeded = false;
    }
  }

  public getStorageQuota = () => this.httpService.get(this.apiEndpoint.GetStorageQuotaUrl);

  public getAccountDataQueryString = (): string => {
    const accountKey = this.accountService.accountKey;
    const pageid = this.accountService.pageid;
    const typename = this.accountService.typename;
    const orgname = this.accountService.orgname;
    return `accountKey=${accountKey}&id=${pageid}&orgname=${orgname}&typename=${typename}&callerpage=ddeditor`;
  }
}
